module.exports = __webpack_public_path__ + "media/main_video.4900667a.mp4";